module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "register-form"
  }, [(_vm.state == 'resent' || _vm.state == 'done') ? _c('div', {
    staticClass: "mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-card__title"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.i18n()[_vm.state].title))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand loading"
  }, [_c('p', [_vm._v(_vm._s(_vm.i18n()[_vm.state].text({
    email: _vm.email
  })))])])]) : _vm._e(), _vm._v(" "), (_vm.state != 'resent' && _vm.state != 'done') ? _c('div', {
    staticClass: "mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-card__title mdl-card-colo"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.i18n().title))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand"
  }, [(_vm.error) ? _c('div', {
    staticClass: "error"
  }, [(_vm.error) ? _c('span', [_vm._v(_vm._s(_vm.i18n().errors[_vm.error] || _vm.error))]) : _vm._e(), _vm._v(" "), (_vm.error == 'registrationNotConfirmed') ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.resend
    }
  }, [_vm._v(_vm._s(_vm.i18n().resendButton))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('form', {
    class: {
      blurred: _vm.state == 'working'
    },
    on: {
      "submit": _vm.register
    }
  }, [_c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstName),
      expression: "firstName"
    }],
    ref: "firstName",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "firstName",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "firstName"
    }
  }, [_vm._v(_vm._s(_vm.i18n().firstName))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastName),
      expression: "lastName"
    }],
    ref: "lastName",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "lastName",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "lastName"
    }
  }, [_vm._v(_vm._s(_vm.i18n().lastName))])]), _vm._v(" "), _c('PhoneInput', {
    staticClass: "phoneNumber",
    attrs: {
      "value": _vm.phoneNumber,
      "required": _vm.required,
      "invalid": _vm.phoneNumberInvalid,
      "label": _vm.i18n().phoneNumber
    },
    on: {
      "update:value": function($event) {
        _vm.phoneNumber = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    ref: "email",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "email",
      "id": "email",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "email"
    }
  }, [_vm._v(_vm._s(_vm.i18n().email))])]), _vm._v(" "), (_vm.passwordTooSimple) ? _c('div', {
    staticClass: "error"
  }, [_c('span', [_vm._v(_vm._s(_vm.i18n().passwordTooSimple))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    ref: "password",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "password",
      "id": "password",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "password"
    }
  }, [_vm._v(_vm._s(_vm.i18n().password))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password2),
      expression: "password2"
    }],
    ref: "password2",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "password",
      "id": "password2",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.password2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "password2"
    }
  }, [_vm._v(_vm._s(_vm.i18n().retypePassword))]), _vm._v(" "), (_vm.notMatch) ? _c('span', {
    staticClass: "mdl-textfield__error"
  }, [_vm._v(_vm._s(_vm.i18n().notMatch))]) : _vm._e()]), _vm._v(" "), _c('vue-recaptcha', {
    ref: "recaptcha",
    attrs: {
      "sitekey": _vm.recaptchaSiteKey
    },
    on: {
      "verify": _vm.verified
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.i18n().submit) + "\n        ")])], 1), _vm._v(" "), (_vm.state == 'working') ? _c('div', {
    staticClass: "working"
  }, [_c('div', {
    staticClass: "mdl-spinner mdl-js-spinner is-active"
  })]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a097357"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/emailPassword/RegisterForm.vue
// module id = 456
// module chunks = 0